// src/components/StreamingText.tsx

import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useStreamingText } from '../hooks/useStreamingText';
import { AnimationConfig } from '../config/animationConfig';
import './StreamingText.scss';

interface StreamingTextProps {
  text: string;
  startDelay?: number;
  className?: string;
  onComplete?: () => void;
}

const chunkVariants = {
  hidden: {
    opacity: 0,
    x: 20,
    scale: 1.1
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: AnimationConfig.text.animationDuration,
      ease: AnimationConfig.easing.spring,
    }
  }
};

export const StreamingText: React.FC<StreamingTextProps> = ({
  text,
  startDelay = AnimationConfig.text.startDelay,
  className,
  onComplete
}) => {
  const { chunks, visibleChunks } = useStreamingText(text, startDelay);

  useEffect(() => {
    if (visibleChunks === chunks.length && chunks.length > 0) {
      requestAnimationFrame(() => {
        onComplete?.();
      });
    }
  }, [visibleChunks, chunks.length, onComplete]);

  return (
    <div className={`streaming-text ${className || ''}`}>
      {chunks.map((chunk, index) => (
        <motion.span
          key={`chunk-${index}`}
          variants={chunkVariants}
          initial="hidden"
          animate={index < visibleChunks ? "visible" : "hidden"}
          dangerouslySetInnerHTML={{ __html: chunk.html }}
        />
      ))}
    </div>
  );
};